import { createContext, useContext } from 'react';

export interface FmMapViewportController {
  fit: () => void;
  zoomIn: () => void;
  zoomOut: () => void;
}

export interface FmMapViewportContextValue {
  controller: FmMapViewportController | null;
  register: (controller: FmMapViewportController | null) => void;
}

export const FmMapViewportContext =
  createContext<FmMapViewportContextValue | null>(null);

export function useFmMapViewport(): FmMapViewportContextValue {
  const value = useContext(FmMapViewportContext);
  if (!value) {
    throw new Error('Map viewport controls require FmMapViewportProvider.');
  }
  return value;
}

export function useOptionalFmMapViewport(): FmMapViewportContextValue | null {
  return useContext(FmMapViewportContext);
}
